<div
    (click)="mostarMenu()"
    id="entidades"
    [@openClose]="showSevicios ? 'open' : 'closed'"
    class="content-servicios-entidades" 
    (mouseover)="eventoOver($event)" (mouseout)="eventoOver($event)">
    <div class="header-entidades">
        <div class="icono-museo">
            <span class="govco-account-balance"></span>
        </div>
        <h6>SERVICIOS PARA ENTIDADES</h6>
    </div>
    <div class="content-list">
        <ul>
            <li>
                <a id="biblioteca" class="text-2" [href]="urlBiblioteca" rel="noopener" target="_blank">Biblioteca</a>
            </li>
            <li>
                <a id="c-herramientas" class="text-2" [href]="urlCajaHerramientas" rel="noopener" target="_blank">Caja de herramientas</a>
            </li>
            <li>
                <a id="plan-integracion" class="text-2" appValidarUrl [href]="urlPlanIntegracion" rel="noopener" target="_blank">Plan de integración</a>
            </li>
            <li>
                <a id="territorial" class="text-2" appValidarUrl href="https://home.micolombiadigital.gov.co/territorial/" rel="noopener" target="_blank">GOV.CO/Territorial</a>
            </li>
        </ul>
    </div>
    <div class="content-tooltip" 
        *ngIf="enableToolTip"
        [@openCloseToolTip]="showToolTip ? 'open' : 'closed'"
        (@openCloseToolTip.done)="onAnimationEvent()">
        <div class="content-text-shadow"></div>
        <div class="content-arrow"></div>
        <div class="content-text">
            <p class="text-2">Conoce todos los Recursos y herramientas para entidades</p>
        </div>
    </div>
</div>
